/**
 * Server error code returned by import endpoints (CNJ / OAB) when the failure
 * is the Judit process-monitoring outage (vendor account quota-blocked).
 * Must match the literal emitted by lexter-copilot-server verbatim.
 */
export const MONITORING_TEMPORARILY_UNAVAILABLE = "MONITORING_TEMPORARILY_UNAVAILABLE";

/**
 * Honest, user-facing message shown when an import fails specifically because
 * process monitoring is temporarily unavailable.
 */
export const MONITORING_UNAVAILABLE_IMPORT_MESSAGE =
  "O monitoramento de processos está temporariamente indisponível. " +
  "Já estamos trabalhando para normalizar — tente importar novamente em breve.";
